import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "tt" }

import { Alzguard, Comments, Inquiry, Introduction, Saemitalk } from "./parts";
import { onMounted, onUnmounted, ref } from "vue";
import ScrollToTop from "../components/common/ScrollToTop.vue";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const display = ref("none");

const result = ref({
  main: "",
  azg: "",
  smt: "",
  comments: "",
  inquiry: "",
  footer: "",
});

const handleScroll = () => {
  const scrollY = window.scrollY;
  if (scrollY < 200) {
    display.value = "none";
  } else {
    display.value = "inherit";
  }
};

onMounted(() => {
  addEventListener("scroll", handleScroll);

  const main = document.querySelector("#main");
  const azg = document.querySelector("#azg");
  const smt = document.querySelector("#smt");
  const comments = document.querySelector("#comments");
  const inquiry = document.querySelector("#inquiry");
  const footer = document.querySelector("#footer");

  const io = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.target) return;
        result.value[entry.target.id] = entry.isIntersecting;
      });
      // TODO: 스크롤 위치 따라서 포커싱 바꾸는 함수 들어가는 자리
      // console.log(result.value);
      if (result.value.main) {
        // console.log("main");
        history.replaceState({ data: "main" }, "main", "/");
      } else if (!result.value.main && result.value.azg) {
        // console.log("azg");
        history.replaceState({ data: "azg" }, "azg", "/#azg");
      } else if (!result.value.azg && result.value.smt) {
        // console.log("smt");
        history.replaceState({ data: "smt" }, "smt", "/#smt");
      } else if (
        (!result.value.comments && result.value.inquiry) ||
        result.value.footer
      ) {
        // console.log("inquiry");
        history.replaceState({ data: "inquiry" }, "inquiry", "/#inquiry");
      } else {
        // console.log("comments");
        history.replaceState({ data: "comments" }, "comments", "/#comments");
      }
    },
    { threshold: 0, rootMargin: "-65px 0px 0px 0px" }
  );

  if (main && azg && smt && comments && inquiry && footer) {
    io.observe(main);
    io.observe(azg);
    io.observe(smt);
    io.observe(comments);
    io.observe(inquiry);
    io.observe(footer);
  }
});

onUnmounted(() => {
  removeEventListener("scroll", handleScroll);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(Introduction)),
    _createVNode(_unref(Alzguard)),
    _createVNode(_unref(Saemitalk)),
    _createVNode(_unref(Comments)),
    _createVNode(_unref(Inquiry)),
    _createVNode(ScrollToTop, { display: display.value }, null, 8, ["display"])
  ]))
}
}

})